import { useTranslation } from "react-i18next";

export default function useTableColumns() {
    const { t } = useTranslation(['gestao_de_aulas']);
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const tableColumns = [
    {
      field: 'nmTurma',
      headerName: t('gestao_de_aulas:className'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.2,
    },
    {
      field: 'nmCurso',
      headerName: t('gestao_de_aulas:course'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.2,
    },
    {
      field: 'dsModalidade',
      headerName: t('gestao_de_aulas:modality'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.1,
    },
    {
      field: 'nmInstrutor',
      headerName: t('gestao_de_aulas:instructor'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.1,
    },
    {
      field: 'dtInicio',
      headerName: t('gestao_de_aulas:startDate'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.1,
    },
    {
      field: 'dtTermino',
      headerName: t('gestao_de_aulas:endDate'),
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.1,
    },
    {
      field: 'botoes',
      headerName: '',
      width:
        getWindowDimensions().width < 800
          ? 450
          : getWindowDimensions().width * 0.1,
    },
  ];

  return {
    tableColumns,
  };
}
